/**
 * Country & Language Synchronization
 * 
 * Automatically switches the language based on the selected country,
 * unless the user has manually overridden the language preference.
 */
document.addEventListener('DOMContentLoaded', () => {
    // Country to Language Mapping (ISO Codes)
    const countryToLanguageMap = {
        'BA': 'bs', // Bosnia -> Bosnian
        'HR': 'hr', // Croatia -> Croatian
        'SI': 'sl', // Slovenia -> Slovenian
        'RS': 'sr', // Serbia -> Serbian
        'ME': 'sr', // Montenegro -> Serbian
        'DE': 'de', // Germany -> German
        'AT': 'de', // Austria -> German
        'IT': 'it', // Italy -> Italian
        'ES': 'es', // Spain -> Spanish
        'FR': 'fr', // France -> French
    };

    // Default fallback language
    const DEFAULT_LANGUAGE = 'en';

    // LocalStorage/SessionStorage Keys
    const LS_PENDING_SYNC = 'shopify_pending_language_sync';
    const LS_MANUAL_OVERRIDE = 'shopify_manual_language_override';
    const SS_SYNC_ATTEMPTS = 'shopify_sync_attempts';

    // Current State (Injected from Liquid)
    const currentCountry = window.ShopifyCurrentCountry;
    const currentLanguage = window.ShopifyCurrentLanguage;

    if (!currentCountry || !currentLanguage) return;

    // --- Helper: Normalize Language Code (e.g., 'bs-BA' -> 'bs') ---
    const getBaseLanguage = (code) => code.split('-')[0].toLowerCase();

    // --- 1. Handle Language Auto-Sync on Page Load ---
    if (localStorage.getItem(LS_PENDING_SYNC) === 'true') {
        const targetLanguage = countryToLanguageMap[currentCountry] || DEFAULT_LANGUAGE;
        const currentBase = getBaseLanguage(currentLanguage);
        const targetBase = getBaseLanguage(targetLanguage);

        // Safety: Limit attempts to prevent infinite loops if a language is unavailable/unmapped
        let attempts = parseInt(sessionStorage.getItem(SS_SYNC_ATTEMPTS) || '0');
        
        if (attempts >= 2) {
            localStorage.removeItem(LS_PENDING_SYNC);
            sessionStorage.removeItem(SS_SYNC_ATTEMPTS);
            return;
        }

        // Only switch if the base languages don't match
        if (currentBase !== targetBase) {
            sessionStorage.setItem(SS_SYNC_ATTEMPTS, (attempts + 1).toString());
            
            // Note: We DON'T remove LS_PENDING_SYNC yet, we want it to persist through one redirect 
            // unless we successfully find and click the link.
            const switched = switchLanguage(targetLanguage);
            
            if (!switched) {
                localStorage.removeItem(LS_PENDING_SYNC);
                sessionStorage.removeItem(SS_SYNC_ATTEMPTS);
            }
        } else {
            localStorage.removeItem(LS_PENDING_SYNC);
            sessionStorage.removeItem(SS_SYNC_ATTEMPTS);
        }
    }

    // --- 2. Intercept Changes ---
    const localizationForms = document.querySelectorAll('localization-form');

    localizationForms.forEach(form => {
        const items = form.querySelectorAll('.js-disclosure-link, button[name="country_code"]');

        items.forEach(item => {
            item.addEventListener('click', (e) => {
                // Check if this form is specifically for Country
                const countryInput = form.querySelector('input[name="country_code"]');
                const isCountryChange = !!countryInput && (item.dataset.value || item.name === 'country_code');

                if (isCountryChange) {
                    localStorage.setItem(LS_PENDING_SYNC, 'true');
                    localStorage.removeItem(LS_MANUAL_OVERRIDE);
                    sessionStorage.removeItem(SS_SYNC_ATTEMPTS); // Reset attempts
                }

                // Check if this is a manual language override
                const languageInput = form.querySelector('input[name="locale_code"]');
                if (languageInput) {
                    localStorage.setItem(LS_MANUAL_OVERRIDE, 'true');
                    localStorage.removeItem(LS_PENDING_SYNC); // Manual choice wins
                }
            });
        });
    });

    // --- Helper: Switch Language ---
    function switchLanguage(targetLangCode) {
        const forms = document.querySelectorAll('localization-form');
        let targetLink = null;
        const targetBase = getBaseLanguage(targetLangCode);

        for (const form of forms) {
            if (form.querySelector('input[name="locale_code"]')) {
                // Try exact match first
                targetLink = form.querySelector(`[data-value="${targetLangCode}"]`);
                
                // Fallback to base match (e.g., find 'bs-BA' if searching for 'bs')
                if (!targetLink) {
                    const links = form.querySelectorAll('.js-disclosure-link');
                    for (const link of links) {
                        if (getBaseLanguage(link.dataset.value || '') === targetBase) {
                            targetLink = link;
                            break;
                        }
                    }
                }
                
                if (targetLink) break;
            }
        }

        if (targetLink) {
            targetLink.click();
            return true;
        }

        return false;
    }
});
